import { on } from '@ember/modifier';
/* eslint-disable ember/no-computed-properties-in-native-classes */
import { action, computed, set } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { PrismComboSelectInput, PrismIcon } from '@mylighthouse/prism-ember';
// @ts-expect-error: Incorrect type
import preventDefault from 'ember-event-helpers/helpers/prevent-default';
import { t } from 'ember-intl';
import {
  REPORT_TYPE_MARKETPARITY,
  REPORT_TYPE_PARITY,
  REVERSE_REPORT_TYPE_CHOICES,
  TYPE_PARITY,
  TYPE_RATES,
} from 'frontend-utils/utils/constants/constant-values';
import GeneralDropdownsTriggersTriggerPowerSelectDelete from 'lumen/components/general/dropdowns/triggers/trigger-power-select-delete';
import GeneralIconWithTooltip from 'lumen/components/general/icon-with-tooltip';
import GeneralReportScheduleReportsModals from 'lumen/components/general/report-schedule/reports-modals';
import can from 'lumen/helpers/can';
import { RATE_PARAMS } from 'lumen/utils/constants/general-constants';
import { allSettled } from 'rsvp';

interface SettingsReportsTablesCellsTdCtaSignature {
  Args: {
    cellData: unknown;
    row: unknown;
  };
}

export default class SettingsReportsTablesCellsTdCta extends Component<SettingsReportsTablesCellsTdCtaSignature> {
  @service declare access: Services['access'];
  @service declare alerting: Services['alerting'];
  @service('hotel-and-market')
  declare hotelAndMarketService: Services['hotel-and-market'];
  @service declare intl: Services['intl'];

  @tracked isEditPopUpVisible = false;

  @computed(
    'args.cellData.createdBy.id',
    'hotelAndMarketService.user.id',
    'reportgroup.receivers',
    'reports.length',
  )
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get deleteAll() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      this.args.cellData?.createdBy?.id ===
        this.hotelAndMarketService.user?.id &&
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      this.reports?.length !== 1 &&
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
      this.reportgroup?.receivers.reduce(
        // @ts-expect-error: Incorrect type
        (containsReceiver, receiver) =>
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
          receiver.id === this.hotelAndMarketService.user?.id ||
          containsReceiver,
        false,
      )
    );
  }

  @computed('reports.length')
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get deleteOptions() {
    return [
      {
        label: this.intl.t('reports.delete_reports_creator', {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
          count: this.reports?.length,
        }),
        deleteSelf: false,
      },
      { label: this.intl.t('reports.delete_single_report'), deleteSelf: true },
    ];
  }

  @computed(
    'access.{featureFlags.isStaffUser}',
    'reportgroup.{createdBy,receivers}',
    'reports',
  )
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get isDeletable() {
    if (isEmpty(this.reports)) {
      return false;
    }

    // @ts-expect-error: Incorrect type
    return this.access.can('report.delete', this.reportgroup);
  }

  @computed(
    'access.{featureFlags.isStaffUser}',
    'reportgroup.{createdBy,receivers}',
    'reports',
  )
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get isEditable() {
    if (isEmpty(this.reports)) {
      return false;
    }

    // @ts-expect-error: Incorrect type
    return this.access.can('report.edit', this.reportgroup);
  }

  @computed('shopconfigs.length', 'type')
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get isEditDisabled() {
    return (
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      this.shopconfigs?.length === 0 &&
      (this.type === TYPE_RATES || this.type === TYPE_PARITY)
    );
  }

  @computed('reportgroup.filters.{bar,flexible}')
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get rateParam() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (this.reportgroup?.filters?.bar) {
      return RATE_PARAMS.BEST_FLEX;
    }

    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (this.reportgroup?.filters?.flexible) {
      return RATE_PARAMS.FLEXIBLE;
    }

    // THIRD_PARTY reportes can't be scheduled

    return RATE_PARAMS.LOWEST;
  }

  @computed('args.cellData')
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get reportgroup() {
    return this.args.cellData;
  }

  @computed('args.cellData.reports')
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get reports() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return this.args.cellData?.reports;
  }

  @computed('reportgroup.shopconfigs')
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get shopconfigs() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call
      this.reportgroup?.shopconfigs
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        .slice()
        // @ts-expect-error: Incorrect type
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        .sort((a, b) => a.shopLength - b.shopLength)
    );
  }

  @computed('reportgroup.{type,reports}')
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get subtype() {
    if (
      // @ts-expect-error: Incorrect type
      this.reportgroup?.type === REPORT_TYPE_PARITY ||
      // @ts-expect-error: Incorrect type
      this.reportgroup?.type === REPORT_TYPE_MARKETPARITY
    ) {
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
      return this.reportgroup?.reports?.[0]?.filters?.subtype;
    }

    return null;
  }

  @computed('reportgroup.type')
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get type() {
    // @ts-expect-error: Incorrect type
    if (this.reportgroup?.type) {
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
      return REVERSE_REPORT_TYPE_CHOICES[this.reportgroup?.type];
    }

    return null;
  }

  @action
  closeScheduleModal(): void {
    this.isEditPopUpVisible = false;
  }

  // @ts-expect-error: Incorrect type
  @action async deleteReport(option): Promise<void> {
    const confirmWasClicked = await this.alerting.showConfirmWarningAlert({
      title: this.intl.t('settings.reports.delete_report'),
      text: this.intl.t('general.are_you_sure'),
    });

    if (confirmWasClicked) {
      // This will be an array of promises to pass to ember RSVP
      const promises = [];

      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      if (option && option.deleteSelf) {
        // Only delete yourself from the report group
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
        const report = this.reports.find(
          // @ts-expect-error: Incorrect type
          (reportArgument) =>
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            reportArgument.receiver?.id === this.hotelAndMarketService.user?.id,
        );
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
        promises.push(report.destroyRecord());
      } else {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const reports = [...this.reports];
        // @ts-expect-error: Incorrect type
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        this.reportgroup.deleteRecord();
        reports.forEach((report) => {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
          promises.push(report.destroyRecord());
        });
      }

      allSettled(promises).then(() => {
        // @ts-expect-error: Incorrect type
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        this.args.row.doRefresh();
      });
    }
  }

  @action
  showEditReport(): void {
    if (!this.isEditDisabled) {
      set(this, 'isEditPopUpVisible', true);
    }
  }

  <template>
    {{! @glint-nocheck }}
    <div class="settings-report-cta">
      {{#if this.isEditable}}
        {{#if this.isEditDisabled}}
          <div class="settings-report-cta__edit-tooltip">
            <GeneralIconWithTooltip
              @iconName="edit-pencil"
              @side="left"
              @tooltipContent={{t "settings.reports.no_shopconfigs_warning"}}
            />
          </div>
        {{else}}
          <button
            class="button--unstyled settings-report-cta__button
              {{if
                this.isEditDisabled
                'settings-report-cta__button--disabled'
              }}"
            type="button"
            {{on "click" (preventDefault this.showEditReport)}}
          >
            <PrismIcon @name="edit-pencil" @size="extra-small" />
          </button>
        {{/if}}
      {{/if}}
      {{#if this.isDeletable}}
        {{#if this.deleteAll}}
          <PrismComboSelectInput
            @horizontalPosition="right"
            @onChange={{this.deleteReport}}
            @options={{this.deleteOptions}}
            @unsafe_triggerComponent={{GeneralDropdownsTriggersTriggerPowerSelectDelete}}
            @value={{null}}
          />
        {{else}}
          <button
            class="button--unstyled settings-report-cta__button
              {{if
                this.isEditDisabled
                'settings-report-cta__button--disabled'
              }}"
            type="button"
            {{on "click" (preventDefault this.deleteReport)}}
          >
            <PrismIcon @name="bin" @size="extra-small" />
          </button>
        {{/if}}
      {{/if}}
    </div>
    <GeneralReportScheduleReportsModals
      @brands={{this.reportgroup.filters.brands}}
      @canCreateNewUser={{can "report.create.other.new" this.reportgroup}}
      @canCreateOtherReports={{can
        "report.create.other.existing"
        this.reportgroup
      }}
      @compsetAvailable={{true}}
      @compsetId={{this.reportgroup.filters.compset}}
      @doRefresh={{@row.doRefresh}}
      @edit={{true}}
      @hotel={{this.reportgroup.hotel}}
      @isShowingScheduleModal={{this.isEditPopUpVisible}}
      @los={{this.reportgroup.filters.los}}
      @managementTypes={{this.reportgroup.filters.management_types}}
      @market={{this.reportgroup.market}}
      @maxPersons={{this.reportgroup.filters.persons}}
      @mealPlan={{this.reportgroup.filters.mealtype}}
      @membershipType={{this.reportgroup.filters.membershiptype}}
      @onCloseScheduleModal={{this.closeScheduleModal}}
      @otaId={{this.reportgroup.filters.ota}}
      @passedShopconfigs={{this.shopconfigs}}
      @rateChanges={{this.reportgroup.filters.ratechange_days}}
      @rateParam={{this.rateParam}}
      @refreshAfterEdit={{true}}
      @reportgroup={{this.reportgroup}}
      @roomType={{this.reportgroup.filters.room}}
      @subtype={{this.subtype}}
      @type={{this.type}}
      {{! TODO: setting compsetAvailable as true is a temporal solution to avoid the problem in SH-21416 }}
    />
  </template>
}
